module.exports = __webpack_public_path__ + "static/thumb-cb3f9a60ab6a2d605b475233361f6d60.png";